import ActivityLink from './ActivityLink';

export default ActivityLink;
